'use client';

import cn from 'clsx';
import s from './product-specs.module.css';

const Temperature = ({ temperature, isCentigrade, setIsCentigrade }) => {
    if (!temperature) return null;

    const {
        temperature_low_in_c,
        temperature_high_in_c,
        temperature_low_in_f,
        temperature_high_in_f,
    } = temperature;

    const tempRangeInC = `${temperature_low_in_c}-${temperature_high_in_c} DEGREES`;
    const tempRangeInF = `${temperature_low_in_f}-${temperature_high_in_f} DEGREES`;

    return (
        <div className={s.row}>
            <dt className={cn(s.label, 'mmds-copy-three')}>Temperature Range</dt>
            <dd className={cn(s.cluster, 'mmds-copy-three-detail')}>
                {isCentigrade ? tempRangeInC : tempRangeInF}
                <button
                    onClick={() => setIsCentigrade(true)}
                    className={isCentigrade ? s.selected : ''}
                >
                    C
                </button>
                <button
                    onClick={() => setIsCentigrade(false)}
                    className={!isCentigrade ? s.selected : ''}
                >
                    F
                </button>
            </dd>
        </div>
    );
};

export default Temperature;
